import { Typography } from '@components/style/Typography';
import { Image } from '@components/style/essential-ui/Image';
import { getMilesText, getNumberAmountText } from '@services/utils/FormatHelper';
import { theme } from '@theme';
import styled from 'styled-components';
import { StyledColumn, StyledRow } from './Style';

const VehicleDetails = (props) => {
  const isFallbackImageStyle =
    props.data.imageUrl ===
    `https://static.findmyupgrade.com/stockimage/${props.data.chromeId}.jpg`;

  return (
    <>
      <VehicleImageData
        data-testid='contract-vehicle-image'
        justifyContent='space-between'
        alignItems='flex-end'
        isFallbackImageStyle={isFallbackImageStyle}
      >
        <ImageWrapper>
          <Image
            className={isFallbackImageStyle ? 'fallback-vehicle' : 'vehicle'}
            src={
              props.data.imageUrl
                ? props.data.imageUrl
                : `https://static.findmyupgrade.com/miscimages/car-image-holder-2.png`
            }
            onError={({ currentTarget }) => {
              currentTarget.src =
                'https://static.findmyupgrade.com/miscimages/car-image-holder-2.png';
              currentTarget.className = 'vehicle';
            }}
            alt={props.data.model ? props.data.model : ''}
          />
        </ImageWrapper>
      </VehicleImageData>
      <Wrapper data-testid='contract-vehicle-details'>
        <tbody>
          <StyledRow>
            <StyledColumn columnSize='col-sm-12'>
              <Typography
                size={theme.typography.h3}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.darkGray}
              >
                {props.data.year}&nbsp;{props.data.model}
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-12'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.darkGray}
              >
                {props.data.trim}
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-12'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.grey}
              >
                VIN:&nbsp;{props.data.vin}
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h5}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.wetAsphalt}
              >
                Vehicle Type
              </Typography>
            </StyledColumn>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h5}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.wetAsphalt}
              >
                Delivery Miles
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.normal}
                color={theme.palette.grey}
              >
                {props.data.isNew ? 'New' : 'Pre-owned'}
              </Typography>
            </StyledColumn>
            <StyledColumn columnSize='col-sm-6'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.normal}
                color={theme.palette.basicGray}
              >
                {getMilesText(props.data.deliveryMileage ? props.data.deliveryMileage : 0)}
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-12'>
              <Typography
                size={theme.typography.h5}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.wetAsphalt}
              >
                Color
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-12'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.normal}
                color={theme.palette.basicGray}
              >
                {props.data.vehicleExtColor}
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-12'>
              <Typography
                size={theme.typography.h5}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.wetAsphalt}
              >
                MSRP
              </Typography>
            </StyledColumn>
          </StyledRow>
          <StyledRow>
            <StyledColumn columnSize='col-sm-12'>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.semibold}
                color={theme.palette.dusty}
              >
                {props.data.msrp ? '$ ' : ''}
              </Typography>
              <Typography
                size={theme.typography.h4}
                fontWeight={theme.typography.fontWeights.normal}
                color={theme.palette.basicGray}
              >
                {props.data.msrp ? getNumberAmountText(Number(props.data.msrp)) : 'N/A'}
              </Typography>
            </StyledColumn>
          </StyledRow>
        </tbody>
      </Wrapper>
    </>
  );
};

export default VehicleDetails;

const StyledTable = styled.table.attrs({
  className: 'table mt-4 no-border-bottom',
})`
  & tr:last-child td {
    border-bottom: 0;
  }
`;

const Wrapper = styled.table`
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 20px;
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  font-family: proxima-nova-n4, proxima-nova, Helvetica, arial, sans-serif;
  -webkit-font-smoothing: antialiased;

  & tr {
    padding-top: 10px;
    line-height: 25px;
  }
  & tr:nth-child(1) {
    padding-top: 5px;
  }
  & tr:nth-child(2) {
    padding-top: 5px;
  }
  & tr:nth-child(3) {
    padding-top: 5px;
  }
  & tr:nth-child(5) {
    padding-top: 5px;
  }
  & tr:nth-child(7) {
    padding-top: 5px;
  }
  & tr:nth-child(9) {
    padding-top: 5px;
  }
`;

const ImageWrapper = styled.div`
  max-width: 250px;
  .vehicle {
    max-height: 125px;
    width: 100%;
  }
  .fallback-vehicle {
    max-height: 100px;
    width: 100%;
    margin: 10px 0 10px 0;
  }
`;

type VehicleImageDataProps = {
  justifyContent?: string;
  alignItems?: string;
  isFallbackImageStyle?: boolean;
};

const VehicleImageData = styled.div.attrs({})<VehicleImageDataProps>`
    padding-left: 30px;
    padding-right: 30px;
    margin: 20px 20px 10px 20px;
    background-color: ${(props) => (props.isFallbackImageStyle ? '' : props.theme.palette.white)}};
    display: flex;
    flex-direction: column;
    justify-content: ${(props) => props.justifyContent ?? 'normal'};
    align-items: ${(props) => props.alignItems ?? 'normal'};
    align-content: center;
    flex-wrap: wrap;
`;
